import React, { useEffect, useState } from "react";
import style from "./setting.module.scss";
import Skeleton from "../skeleton/skeleton"
{/* <Skeleton type='rectangle' width='280px' height='44px' /> */ }
const WalletSkeleton = (props) => {

    return <div className={style.wrapper}>
        <div className={style.header}>
            <h1><Skeleton type='rectangle' width='96px' height='44px' /></h1>
        </div>

        <div className={style.mainFlexWrapper}>
            <div className={style.selectTimeWrapper}>
                <div className={style.selectTimedescription}><Skeleton type='rectangle' width='296px' height='44px' /></div>
                <div className={style.timesWrapper}>
                    <Skeleton type='rectangle' width='52px' height='48px' />
                    <Skeleton type='rectangle' width='52px' height='48px' />
                    <Skeleton type='rectangle' width='52px' height='48px' />
                    <Skeleton type='rectangle' width='52px' height='48px' />
                    <Skeleton type='rectangle' width='52px' height='48px' />
                </div>
                <div className={style.timeInputWrapper}>
                    <Skeleton type='rectangle' width='100%' height='44px' />
                </div>
                <div className={style.buttonWrapper}>
                    <Skeleton type='rectangle' width='100%' height='44px' />
                </div>
            </div>
            <div className={style.selectVariantWrapper} style={{ padding: 0, background: 'none' }}>
                <Skeleton type='rectangle' width='100%' height='440px' />
            </div>
        </div>

        <div className={style.exceptionsWrapper}>
            <div className={style.exceptionsHeader}>
                <div className={style.paginationWrapper}>
                    <div className={style.pagination}>
                        <div className={style.Dropdown} style={{ display: 'inline-flex', gap: '16px' }}>
                            <Skeleton type='rectangle' width='196px' height='44px' />
                            <Skeleton type='rectangle' width='46px' height='44px' />
                            <Skeleton type='rectangle' width='56px' height='44px' />
                            <Skeleton type='rectangle' width='56px' height='44px' />
                        </div>
                    </div>
                </div>
                <h5 className={style.exceptionsTitle}><Skeleton type='rectangle' width='196px' height='44px' /></h5>
            </div>

            <button className={style.addException}>
                <Skeleton type='rectangle' width='88px' height='44px' />
            </button>

            <div className={style.listWrapper}>
                <div className={style.listWrapper} style={{ display: 'inline-flex', flexDirection: 'column', gap: '16px' }}>
                    <Skeleton type='rectangle' width='100%' height='44px' />
                    <Skeleton type='rectangle' width='100%' height='44px' />
                    <Skeleton type='rectangle' width='100%' height='44px' />
                    <Skeleton type='rectangle' width='100%' height='44px' />
                </div>
            </div>

            <button
                className={style.addException}
                style={{ marginTop: '20px' }}
            >
                <Skeleton type='rectangle' width='88px' height='44px' />
            </button>
        </div>
    </div>
}
export default WalletSkeleton;
